import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onStart: () => void;
  onDecline: () => void;
};

export default function AdminParticipantsTourOfferDialog({ open, onStart, onDecline }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onDecline}
      aria-labelledby="admin-participants-tour-offer-title"
      aria-describedby="admin-participants-tour-offer-description"
    >
      <DialogTitle id="admin-participants-tour-offer-title">
        {t('participants.adminTour.offerTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="admin-participants-tour-offer-description">
          {t('participants.adminTour.offerDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDecline} color="inherit">
          {t('participants.adminTour.offerDecline')}
        </Button>
        <Button onClick={onStart} variant="contained" color="primary" autoFocus>
          {t('participants.adminTour.offerStart')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
